import React from "react";
import {
  Button,
  IconText,
  Image,
  Input,
} from "@wac-ui-dashboard/wac_component_library";
import Style from "../compareTab.module.scss";
import Select from "react-select";
import useVersionTwo from "./useVersionTwo";

const VersionTwo = ({ statusData }) => {
  const {
    formik,
    excelFormData,
    itemID,
    certificateNumber,
    currentTab,
    getFieldError,
    handleReset,
    handleCVDPassDNOChange,
    handleRFTDNOChange,
    handleCVDDNOChange,
    handleHTPTDNOChange,
    isFlatGradedData,
    handleImageChange,
    imagePreview,
  } = useVersionTwo();

  return (
    <>
      <div className="row gy-3">
        <div className="col-12">
          <h6 className="pro-ttl h6">{itemID}</h6>
          <p className="pro-ttl pro-mb-0">{certificateNumber}</p>
        </div>

        <>
          <div className="col-6">
            <div className="input-wrap pro-mb-4">
              <label
                htmlFor="status2"
                className="pro-font-sm pro-mb-1 pro-fw-medium"
              >
                Status
              </label>
              <Select
                id="status2"
                name="status2"
                placeholder={"Select"}
                className={`pro-input lg  ${
                  getFieldError("status2") && " error"
                }`}
                classNamePrefix="pro-input"
                options={statusData ?? []}
                getOptionLabel={(option) => option?.name}
                getOptionValue={(option) => option?.id}
                onBlur={formik.handleBlur("status2")}
                isMulti={false}
                onChange={(value) => {
                  formik?.setFieldValue("status2", value || null);
                }}
                menuPlacement="auto"
                value={
                  formik.values?.status2
                    ? statusData?.find(
                        (option) => option?.id === formik.values?.status2
                      )
                    : statusData?.find(
                        (option) =>
                          option?.id ===
                          (excelFormData?.process?.status ??
                            excelFormData?.cvd_status)
                      ) ?? null
                }
                isDisabled={currentTab?.[0]?.disabled}
              />
              {getFieldError("status2") && (
                <span className="error-text">{getFieldError("status2")}</span>
              )}
            </div>
          </div>
          <div className={`col-6`}>
            <Input
              label={"Remark"}
              type="text"
              id="remark"
              name="remark"
              className={`pro-input lg ${getFieldError("remark") && " error"}`}
              {...formik.getFieldProps("remark")}
              error={getFieldError("remark")}
              errorMessage={getFieldError("remark")}
              disabled={currentTab?.[0]?.disabled}
            />
          </div>
        </>

        {/* eslint-disable-next-line eqeqeq */}
        <>
          <div className="col-6">
            <div>
              {!isFlatGradedData && (
                <>
                  <h6>RFT</h6>
                  <Input
                    label="Weight"
                    type="text"
                    id={`rft_weight`}
                    name={`rft_weight`}
                    className={`pro-input lg ${
                      getFieldError(`rft_weight`) && " error"
                    }`}
                    value={formik.values.rft_weight}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`rft_weight`)}
                    errorMessage={getFieldError(`rft_weight`)}
                    disabled={currentTab?.[0]?.disabled}
                  />
                  <Input
                    label="Diamond/No"
                    type="text"
                    id={`rft_d_no`}
                    name={`rft_d_no`}
                    className={`pro-input lg ${
                      getFieldError(`rft_d_no`) && " error"
                    }`}
                    value={formik.values.rft_d_no}
                    {...formik.getFieldProps(`rft_d_no`)}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`rft_d_no`)}
                    errorMessage={getFieldError(`rft_d_no`)}
                    onChange={handleRFTDNOChange}
                    disabled={currentTab?.[0]?.disabled}
                  />
                  <Input
                    label="Percentage"
                    type="text"
                    id={`rft_percentage`}
                    name={`rft_percentage`}
                    className={`pro-input lg ${
                      getFieldError(`rft_percentage`) && " error"
                    }`}
                    value={formik.values.rft_percentage}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`rft_percentage`)}
                    errorMessage={getFieldError(`rft_percentage`)}
                    disabled={currentTab?.[0]?.disabled}
                  />
                </>
              )}
              {!isFlatGradedData && (
                <>
                  <h6>CVD</h6>
                  <Input
                    label="Weight"
                    type="text"
                    id={`cvd_weight`}
                    name={`cvd_weight`}
                    className={`pro-input lg ${
                      getFieldError(`cvd_weight`) && " error"
                    }`}
                    value={formik.values.cvd_weight}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`cvd_weight`)}
                    errorMessage={getFieldError(`cvd_weight`)}
                    disabled={currentTab?.[0]?.disabled}
                  />
                  <Input
                    label="Diamond/No"
                    type="text"
                    id={`cvd_d_no`}
                    name={`cvd_d_no`}
                    className={`pro-input lg ${
                      getFieldError(`cvd_d_no`) && " error"
                    }`}
                    value={formik.values.cvd_d_no}
                    {...formik.getFieldProps(`cvd_d_no`)}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`cvd_d_no`)}
                    errorMessage={getFieldError(`cvd_d_no`)}
                    onChange={handleCVDDNOChange}
                    disabled={currentTab?.[0]?.disabled}
                  />
                  <Input
                    label="Percentage"
                    type="text"
                    id={`cvd_percentage`}
                    name={`cvd_percentage`}
                    className={`pro-input lg ${
                      getFieldError(`cvd_percentage`) && " error"
                    }`}
                    value={formik.values.cvd_percentage}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`cvd_percentage`)}
                    errorMessage={getFieldError(`cvd_percentage`)}
                    disabled={currentTab?.[0]?.disabled}
                  />
                </>
              )}
            </div>
          </div>
          <div className="col-6">
            <div>
              {!isFlatGradedData && (
                <>
                  <h6>HPHT</h6>
                  <Input
                    label="Weight"
                    type="text"
                    id={`htpt_weight`}
                    name={`htpt_weight`}
                    className={`pro-input lg ${
                      getFieldError(`htpt_weight`) && " error"
                    }`}
                    value={formik.values.htpt_weight}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`htpt_weight`)}
                    errorMessage={getFieldError(`htpt_weight`)}
                    disabled={currentTab?.[0]?.disabled}
                  />
                  <Input
                    label="Diamond/No"
                    type="text"
                    id={`htpt_d_no`}
                    name={`htpt_d_no`}
                    className={`pro-input lg ${
                      getFieldError(`htpt_d_no`) && " error"
                    }`}
                    value={formik.values.htpt_d_no}
                    {...formik.getFieldProps(`htpt_d_no`)}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`htpt_d_no`)}
                    errorMessage={getFieldError(`htpt_d_no`)}
                    onChange={handleHTPTDNOChange}
                    disabled={currentTab?.[0]?.disabled}
                  />
                  <Input
                    label="Percentage"
                    type="text"
                    id={`htpt_percentage`}
                    name={`htpt_percentage`}
                    className={`pro-input lg ${
                      getFieldError(`htpt_percentage`) && " error"
                    }`}
                    value={formik.values.htpt_percentage}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`htpt_percentage`)}
                    errorMessage={getFieldError(`htpt_percentage`)}
                    disabled={currentTab?.[0]?.disabled}
                  />
                </>
              )}
              {!isFlatGradedData && (
                <>
                  <h6>CVD Pass</h6>
                  <Input
                    label="Weight"
                    type="text"
                    id={`cvd_pass_weight`}
                    name={`cvd_pass_weight`}
                    className={`pro-input lg ${
                      getFieldError(`cvd_pass_weight`) && " error"
                    }`}
                    value={formik.values.cvd_pass_weight}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`cvd_pass_weight`)}
                    errorMessage={getFieldError(`cvd_pass_weight`)}
                    disabled={currentTab?.[0]?.disabled}
                  />
                  <Input
                    label="Diamond/No"
                    type="text"
                    id={`cvd_pass_d_no`}
                    name={`cvd_pass_d_no`}
                    className={`pro-input lg ${
                      getFieldError(`cvd_pass_d_no`) && " error"
                    }`}
                    value={formik.values.cvd_pass_d_no}
                    {...formik.getFieldProps(`cvd_pass_d_no`)}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`cvd_pass_d_no`)}
                    errorMessage={getFieldError(`cvd_pass_d_no`)}
                    onChange={handleCVDPassDNOChange}
                    disabled={currentTab?.[0]?.disabled}
                  />
                  <Input
                    label="Percentage"
                    type="text"
                    id={`cvd_pass_percentage`}
                    name={`cvd_pass_percentage`}
                    className={`pro-input lg ${
                      getFieldError(`cvd_pass_percentage`) && " error"
                    }`}
                    value={formik.values.cvd_pass_percentage}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={getFieldError(`cvd_pass_percentage`)}
                    errorMessage={getFieldError(`cvd_pass_percentage`)}
                    disabled={currentTab?.[0]?.disabled}
                  />
                </>
              )}
            </div>
          </div>
        </>
        {isFlatGradedData &&
          formik?.values?.status2 !== 2 &&
          formik?.values?.status2?.id !== 2 &&
          formik?.values?.status2 !== "" && (
            <>
              <Input
                label={"RFT Diamond/No"}
                type="text"
                id="rft_diamond_number"
                name="rft_diamond_number"
                className={`pro-input lg ${
                  getFieldError("rft_diamond_number") && " error"
                }`}
                {...formik.getFieldProps("rft_diamond_number")}
                error={getFieldError("rft_diamond_number")}
                errorMessage={getFieldError("rft_diamond_number")}
                disabled={currentTab?.[0]?.disabled}
              />
              <Input
                label={"Percentage"}
                type="text"
                id="percentage"
                name="percentage"
                className={`pro-input lg ${
                  getFieldError("percentage") && " error"
                }`}
                {...formik.getFieldProps("percentage")}
                error={getFieldError("percentage")}
                errorMessage={getFieldError("percentage")}
                disabled={currentTab?.[0]?.disabled}
              />

              <div className="input-wrap pro-mb-4">
                <label
                  htmlFor=""
                  className={`pro-font-sm pro-mb-1 pro-fw-medium`}
                >
                  Image
                </label>
                <div className="input-drag">
                  <input
                    type="file"
                    accept=".jpeg,.jpg , .png "
                    className={`pro-input ${
                      formik.errors.image && formik.touched.image && " error"
                    }`}
                    id="image"
                    onBlur={formik.handleBlur("logo")}
                    onChange={(e) => handleImageChange(e)}
                    disabled={currentTab?.[0]?.disabled}
                  />
                  <span className="input-drag-box">
                    <IconText
                      title={
                        (formik?.values?.image?.name ||
                          formik?.values?.image?.original_name) ??
                        `Drop files to attach or browse`
                      }
                    />
                  </span>
                  {formik.touched.image && formik.errors.image && (
                    <span className="error-text">{formik.errors.image}</span>
                  )}
                </div>
                {(imagePreview || formik.values.image?.path) &&(
                    <div className={`col-2 pro-my-2`}>
                      <div className={``}>
                        <Image
                          width={100}
                          height={100}
                          src={imagePreview ? imagePreview : formik.values.image?.path}
                          alt={formik?.values?.image?.name || formik?.values?.image?.original_name}
                        />
                      </div>
                    </div>
                    )}
              </div>
            </>
          )}
      </div>
      <div
        className={`col-12 pro-d-flex pro-py-3 pro-justify-end ${Style.footer_btn_wrap}`}
      >
        <Button
          disabled={currentTab?.[0]?.disabled}
          className={"pro-btn-outline  pro-px-5"}
          onClick={handleReset}
        >
          Reset
        </Button>
        <Button
          disabled={currentTab?.[0]?.disabled}
          className={"pro-btn-primary lg pro-ms-3"}
          type="button"
          onClick={formik?.handleSubmit}
        >
          Update
        </Button>
      </div>
      {/* <ModalLayout show={cnfModal} handleClose={handleModal}>
        <div className="pro-m-5">
          <ConfirmationBox
            title={"Do You want to see extra details?"}
            subTitle={"Click yes to continue"}
            cancelText={"No"}
            cancelAction={handleModal}
            submitText={"Yes"}
            submitAction={handleYes}
            isRight={true}
          />
        </div>
      </ModalLayout> */}
    </>
  );
};

export default VersionTwo;
